"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DivisonName = void 0;
var DivisonName;
(function (DivisonName) {
    DivisonName["Dhaka"] = "Dhaka";
    DivisonName["Chattogram"] = "Chattogram";
    DivisonName["Mymensingh"] = "Mymensingh";
    DivisonName["Khulna"] = "Khulna";
    DivisonName["Rajshahi"] = "Rajshahi";
    DivisonName["Rangpur"] = "Rangpur";
    DivisonName["Sylhet"] = "Sylhet";
    DivisonName["Barisal"] = "Barisal";
})(DivisonName = exports.DivisonName || (exports.DivisonName = {}));
